import styled from "styled-components";

const LayoutStyled = styled.div`
  min-height: 100vh;

  .ant-sider {
    position: fixed;
    height: 100vh;

    .ant-layout-sider-children {
      overflow: auto;
    }

    .ant-layout-sider-zero-width-trigger {
      z-index: 100;
    }

    + .site-layout {
      margin-left: 200px;
    }

    &.ant-layout-sider-below {
      //this css show up on small screen //when the sider collapsible
      position: relative;

      + .site-layout {
        margin-left: 0;
      }
    }
  }

  .site-header {
    background-color: #fff;
    padding: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ececec;
    .path-name {
      display: flex;
      align-items: center;
    }

    p {
      margin-bottom: 0px;
      font-size: 20px;
      line-height: 30px;
      font-weight: 700;
    }

    .back-icon-container {
      padding: 7px 10px 7px 10px;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      margin-right: 10px;
      cursor: pointer;
    }

    .back-icon {
      display: block;
    }
  }

  .site-layout {
    padding-bottom: 40px;
    position: relative;
  }

  .logo {
    max-width: 100%;
    width: 95px;
    margin: 10px 0;
    margin-left: 15px;
  }

  .logo-area {
    text-align: center;
  }

  .store-logo {
    padding: 15px;
    width: 120px;
    max-height: 130px;
    object-fit: contain;
  }

  .site-layout {
    position: relative;
    padding-bottom: 40px;
  }

  .footer-text {
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
    color: #b9b9b9;
    line-height: 30px;
    font-size: 10px;
  }

  .menu {
    padding-top: 15px;
    padding-bottom: 10px;
  }

  .menu-title {
    color: rgba(255, 255, 255, 0.65);
    padding-left: 24px;
    margin-bottom: 0px;
    font-weight: 700;
    line-height: 19px;
  }

  .ant-menu-dark .ant-menu-inline.ant-menu-sub {
    background-color: #001529 !important;
  }

  .submenu-item {
    padding-left: 24px !important;
  }

  .submenu .ant-menu-submenu-arrow {
    display: none !important;
  }

  .ant-menu-item,
  .ant-menu-submenu-title {
    padding-left: 16px !important;
  }

  .submenu .ant-menu-submenu-title {
    font-weight: 700;
    font-size: 12px;
  }
`;

export default LayoutStyled;
